import WorkoutRecommendations from "@/components/WorkoutRecommendations/WorkoutRecommendations";
import React from "react";

const WorkoutRecommendationsPage: React.FC = () => {
  return <WorkoutRecommendations />;
};

export default WorkoutRecommendationsPage;
